import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/alumni-workshops-website/alumni-workshops-website/src/components/workshop-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Introduction to Investing`}</h1>
    <h2>{`2022-03-16 at 1:30pm`}</h2>
    <p><em parentName="p">{`Duration: 1 hour`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20220316T203000Z%2F20220316T213000Z&details=In%20this%20session%2C%20we%27ll%20make%20investments%20easy%20and%20teach%20you%20about%20the%20most%20important%20tax-advantaged%20investment%20accounts%20%28401K%2C%20HSA%2C%20IRA%29.%20By%20the%20end%20of%20the%20session%2C%20you%27ll%20understand%20how%20investments%20work%20and%20how%20to%20leverage%20them.&location=http%3A%2F%2Flovelace-labs.adadev.org&text=Intro%20to%20Investing%20with%20Shirley%20Chu"
        }}>{`Add To Google Calendar`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://outlook.live.com/calendar/0/deeplink/compose?allday=false&body=In%20this%20session%2C%20we%27ll%20make%20investments%20easy%20and%20teach%20you%20about%20the%20most%20important%20tax-advantaged%20investment%20accounts%20%28401K%2C%20HSA%2C%20IRA%29.%20By%20the%20end%20of%20the%20session%2C%20you%27ll%20understand%20how%20investments%20work%20and%20how%20to%20leverage%20them.&enddt=2022-03-16T21%3A30%3A00%2B00%3A00&location=http%3A%2F%2Flovelace-labs.adadev.org&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2022-03-16T20%3A30%3A00%2B00%3A00&subject=Intro%20to%20Investing%20with%20Shirley%20Chu"
        }}>{`Add to Microsoft Calendar`}</a></li>
    </ul>
    <p>{`Want to get started investing, but don't know where to start?`}</p>
    <p>{`We'll make investments easy and teach you about the most important tax-advantaged investment accounts (401K, HSA, IRA). By the end of the session, you'll understand how investments work, and how to leverage them to fund your dream life.`}</p>
    <h2>{`Shirley Chu`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "300px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cf527bc17663e1120faca445d6846673/5a46d/shirley-chu-thumb.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFbElEQVQ4yx3Q7VPahwHA8d/dbt3SGKMCShAl+IAo/IIC8qSAICggICACRpJgYrOoMSZqoiZG09AHNXpWbRLz4NUY2yatuz2k6V3X9nqxW3fNXa/bri+224u93e3NXuzF3u272/6Bz4uP8LjXRKS5guP9rxHODHLn/X1+/tu/8vb9Z+SX1jh3cYJMMoRRLOPMQIr5mQusbKyxeu8R2Wwa0zE1YY8Ji6OW+aUbCGNaBUOBRj74Yp/o8CT527/gwaff0Td+i82dPa4trBGMBuhLh7l7d5P8wpvEkkE6M/1cWVkllerC1WrGZDVgclkQvn+4wg9//hPb95c5cTnPW3c/4sPf/YXu0QW2njxj7vZ7rP7yUy4tvs3mzi6rjz9iammZSDrO+gfvc3owQSjgwmjR0tHtQ9hfzPHHLz9mb8jC3NU8k4s77H75N4amNljd3GZ8Pk9ri4Fcpp14xMP5sz3c31rj48/3ebC3x4kzSXLZONlsgmi3G2HLJbATLeXZdIK5ySnOTq+z8eRrIqk0A7khGnUmxEo51noloqYSjVpJxNPAG6tv0Tv0M2ZnxpiamSDZl6SjoxXhgVPgcUbLdy9fMntnl75Li9x//j2Xl9cRG1pRSpW4tFWccNRxvl1Pk1pOmeQwXS3VBMNu3lma4967KxiMOhIj5xFmDT/iuukVJi0F9GdyrO78nr0XP5DoPYW0SImzycKA18r1mJ2VHhshXTnVZcU0HpWSjloZGR/hwuhJojE7Dz/5EGHFW8x2rpp7s51kzw7w6NcvyK9vU1wsx6Kz8vrAAOeCNtLN1bweMtJnVKOSFqKSFRJrreW1/k78fhP+qJtHL75C+PuWj398u87VrQ00yQyjV2fxBntQyyScT02wO32JfMLKqFfPFf8xUiY11fJiig8dxNagIBs04HWI+Bw6FlbfRPj3NzP8h3+x+ZsvEN0WcuMTmGwuGlS1TGUmuNnj50bQxK2Ml9mQmbF2HW6NnIKDBxBVUrKdOvxeC7lsjIsXTiL8c3+cP3y2Rv7WFHa3kYHhQbT1esoVdcz0prnoa2Ay1MyIS2TQUsOdtJP+5hoOvPpT9CoZUbua/oSH3mSU3kQ7wstFL6Md9YheD3eebHH8zAkOFpRQWqpkOBzkWtTGbNzBUJuehFjBuEePRiHllVcPUKeU0KYvJxV20OJtI5ROIvzqgovPvv2G0JlzTMzO4OvOYGrxI5WV0W5uZjnbxbS/iQFzFaNtdTgbKhB+/BMOFRZQWVqE4agMX3MVg6ePMzg+gfA0W8PD9WVOD4/i8ATROWKE+sbwdHRgbtQTt4lM/A90NxB16jA21lCpklNUfIgySSG15RLcYjnvLMwxNjWF8HxIx9Pt21xb2aIreQ7R2YnZP0IwkSWejBEIdRKPBuiOdxBP+Egl2ggHrdTVKik5XEBFWQlWrZyNpetMz88jfP3JU964t0v/5CqR9GVs7U5EZxZfJEcgEiLeEySe7CTZ4ycZbyPe7SQaduCw1iOVFCItOYxeVcLyjXFm5uYR8lvP8adHaAun8UWH8IdcaJostAZPEerpIRxtJxZtJdZlI+Az4mrRYzVrqdOUUyqXUFxShLZSxmCqg9GbNxEskWFiqSytHgfW9gxdkQBmu4ho78Lt89HmbsLVosNpr8egV///T6k6QoVaQUmpBKm0mCqFFL9Fw7sP7iIobb0EU8PE+7M4/HE8/iBdnWYaDHUYTCKaugpkCimSMgmVtRXorSIWrxWD3YC6/iiHCg8ilxzGVF/J3NwVBJk5iug+SSiWwh/wYXM6Cfit+H0mzPYmCqVFlKmOoKgqR6ZSoGyopcZsRGs8htas44hKgfyIDK/LzKmTaf4L7LoVgr0FXiUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Shirley Chu thumbnail",
            "title": "Shirley Chu thumbnail",
            "src": "/static/cf527bc17663e1120faca445d6846673/5a46d/shirley-chu-thumb.png",
            "srcSet": ["/static/cf527bc17663e1120faca445d6846673/5a46d/shirley-chu-thumb.png 300w"],
            "sizes": "(max-width: 300px) 100vw, 300px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      